import { useToast } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useRequestOrderConfirmationMutation,
  useVerifyOrderConfirmationMutation,
} from 'rtkQuery/sharespro/queries/orders';
import { useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';

import PhoneConfirmationModal from 'presentation/components/shared/modals/PhoneConfirmationModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  orderId: ID;
}

const OrderConfirmationModal: FC<Props> = ({ isOpen, onClose, orderId }) => {
  const { data } = useFetchProfileQuery();

  const [verifyOtp, { isLoading }] = useVerifyOrderConfirmationMutation();

  const toast = useToast();

  const { t } = useTranslation();

  const [requestOrderConfirmation, { isLoading: newCodeRequesting }] =
    useRequestOrderConfirmationMutation();

  return (
    <PhoneConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('orderConfirmation')}
      text={t('codeHasBeenSentToNumber')}
      phoneNumber={data?.phone ?? null}
      onSubmit={async (values) => {
        await verifyOtp({
          otpId: values.otpId as number,
          code: values.code,
          orderId,
        })
          .unwrap()
          .then(() => {
            onClose();
            toast({
              description: t('orderConfirmed'),
              status: 'success',
              position: 'top-right',
              isClosable: true,
            });
          });
      }}
      otpVerifying={isLoading}
      onSendNewCode={async () => {
        return await requestOrderConfirmation(orderId).unwrap();
      }}
      newCodeRequesting={newCodeRequesting}
    />
  );
};

export default OrderConfirmationModal;
